var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[
    'button',
    {
      'button--rounded': _vm.round,
      'button--bordered': _vm.border,
      'button--accent': _vm.color === 'accent',
      'button--main': _vm.color === 'main',
      'button--transparent': _vm.color === 'transparent',
      'button--warning': _vm.color === 'warning',
      'button--wide': _vm.wide,
    } ],attrs:{"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("icon"),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }